/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const es_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión`)
};

const de_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const nl_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versie`)
};

const fr_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version`)
};

const it_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione`)
};

const pt_br2_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão`)
};

const pt_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão`)
};

const ja_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バージョン`)
};

const zh_ud_field_version = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_field_version = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_field_version(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_field_version", locale)
	if (locale === "en") return en_ud_field_version(inputs)
	if (locale === "es") return es_ud_field_version(inputs)
	if (locale === "de") return de_ud_field_version(inputs)
	if (locale === "nl") return nl_ud_field_version(inputs)
	if (locale === "fr") return fr_ud_field_version(inputs)
	if (locale === "it") return it_ud_field_version(inputs)
	if (locale === "pt-BR") return pt_br2_ud_field_version(inputs)
	if (locale === "pt") return pt_ud_field_version(inputs)
	if (locale === "ja") return ja_ud_field_version(inputs)
	return zh_ud_field_version(inputs)
};